import { ProfileValue } from './profile.value';

export class ProfileValueDto {
    firstName?: string;
    lastName?: string;
    description?: string;
    country?: string | null;
    avatarId?: string | null;

    constructor(data: ProfileValue) {
        if (data.firstName !== undefined) {
            this.firstName = data.firstName;
        }
        if (data.lastName !== undefined) {
            this.lastName = data.lastName;
        }
        if (data.description !== undefined) {
            this.description = data.description;
        }
        if (data.country !== undefined) {
            this.country = data.country;
        }

        const originalAvatarStr = data.originalAvatarId != null ? String(data.originalAvatarId) : null;
        if (data.avatarId !== undefined && data.avatarId !== originalAvatarStr) {
            this.avatarId = data.avatarId;
        }
    }
}
